module.exports = __webpack_public_path__ + "static/media/team-introduction-9.6aa03474.jpg";